// The supervisor opens the emailed link with no TradiePass account. `public`
// tells the router guard to skip every login, MFA and onboarding redirect.
export default {
  path: '/external-approval/:token',
  name: 'external-approval',
  meta: { public: true },
  component: () =>
    import(
      /* webpackChunkName: "external-approval" */ '@/views/externalApproval/ExternalApprovalPage.vue'
    ),
}
